import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import { ComponentProps, memo, forwardRef } from 'react';

import LineChartImpl, { LineChartHandle } from './LineChartImpl';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

type LineChartImplProps = ComponentProps<typeof LineChartImpl>;
const areEqual = (prevProps: LineChartImplProps, nextProps: LineChartImplProps) =>
  JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data) &&
  prevProps.chartType === nextProps.chartType;

// eslint-disable-next-line react-refresh/only-export-components
const LineChart = memo(
  forwardRef<LineChartHandle, LineChartImplProps>((props, ref) => (
    <LineChartImpl {...props} ref={ref} />
  )),
  areEqual
);

export type { LineChartHandle };
export default LineChart;
